import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "https://home-inventory-2exr.onrender.com";

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const householdId = localStorage.getItem("household_id");
  if (householdId) {
    config.headers["x-household-id"] = householdId;
  }
  return config;
});

export const householdApi = {
  create: (data) => api.post("/households", data).then((r) => r.data),
  join: (code) => api.get(`/households/join/${code}`).then((r) => r.data),
  get: (id) => api.get(`/households/${id}`).then((r) => r.data),
  update: (id, data) => api.put(`/households/${id}`, data).then((r) => r.data),
};

export const inventoryApi = {
  getAll: () => api.get("/inventory").then((r) => r.data),
  create: (data) => api.post("/inventory", data).then((r) => r.data),
  update: (id, data) => api.put(`/inventory/${id}`, data).then((r) => r.data),
  updateStatus: (id, status, quantity = 1) =>
    api.post(`/inventory/${id}/status`, { status, quantity }).then((r) => r.data),
  delete: (id) => api.delete(`/inventory/${id}`),
};

export const cartApi = {
  getCart: () => api.get("/cart").then((r) => r.data),
  removeItem: (id) => api.delete(`/cart/${id}`),
  sendCart: () => api.post("/cart/send").then((r) => r.data),
  markPurchased: (id) => api.post(`/history/cart/${id}/purchased`).then((r) => r.data),
};

export const historyApi = {
  getHistory: () => api.get("/history").then((r) => r.data),
  clearHistory: () => api.delete("/history/clear"),
};

export const mealplanApi = {
  getWeek: (date) => api.get(`/mealplan/week/${date}`).then((r) => r.data),
  getTemplate: () => api.get("/mealplan/template").then((r) => r.data),
  saveMeal: (date, day, mealType, dishName, isTemplate = false) =>
    api.post(`/mealplan/week/${date}/meal?day=${day}&meal_type=${mealType}&dish_name=${encodeURIComponent(dishName)}&is_template=${isTemplate}`).then((r) => r.data),
  deleteMeal: (mealId) => api.delete(`/mealplan/meal/${mealId}`).then((r) => r.data),
  addIngredient: (mealId, name, inventoryItemId = null) =>
    api.post(`/mealplan/meal/${mealId}/ingredient?ingredient_name=${encodeURIComponent(name)}${inventoryItemId ? `&inventory_item_id=${inventoryItemId}` : ""}`).then((r) => r.data),
  deleteIngredient: (id) => api.delete(`/mealplan/ingredient/${id}`).then((r) => r.data),
  getSummary: (date) => api.get(`/mealplan/week/${date}/summary`).then((r) => r.data),
  addMissingToCart: (date) => api.post(`/mealplan/week/${date}/add-to-cart`).then((r) => r.data),
  copyTemplate: (date) => api.post(`/mealplan/week/${date}/copy-template`).then((r) => r.data),
  sendTomorrow: () => api.post("/mealplan/send-tomorrow").then((r) => r.data),
  getInsights: (date) => api.post(`/mealplan/week/${date}/insights`).then((r) => r.data),
  getWeekNutrition: (date) => api.get(`/mealplan/week/${date}/nutrition`).then((r) => r.data),
  getAiCommentary: (date) => api.post(`/mealplan/week/${date}/ai-commentary`).then((r) => r.data),
  searchInventory: (q) => api.get(`/mealplan/inventory-search?q=${encodeURIComponent(q)}`).then((r) => r.data),
};

export const categoriesApi = {
  getAll: () => api.get("/categories").then((r) => r.data),
  create: (name) => api.post("/categories", { name }).then((r) => r.data),
  delete: (id) => api.delete(`/categories/${id}`),
};

export const recipesApi = {
  search: (q, category = "") => api.get(`/recipes?q=${encodeURIComponent(q)}&category=${encodeURIComponent(category)}`).then((r) => r.data),
  get: (id) => api.get(`/recipes/${id}`).then((r) => r.data),
  save: (dishName, ingredients) =>
    api.post("/recipes", {
      dish_name: dishName,
      ingredients: ingredients.map((name) => ({ ingredient_name: name })),
    }).then((r) => r.data),
  create: (data) => api.post("/recipes", data).then((r) => r.data),
  update: (id, data) => api.put(`/recipes/${id}`, data).then((r) => r.data),
  delete: (id) => api.delete(`/recipes/${id}`),
  getNutrition: (id) => api.post(`/recipes/${id}/nutrition`).then((r) => r.data),
  getNutritionBatch: () => api.post('/recipes/nutrition/batch').then((r) => r.data),
};

export const sharingApi = {
  setUsername: (username) => api.put("/sharing/username", { username }).then((r) => r.data),
  checkUsername: (username) => api.get(`/sharing/username/check/${username}`).then((r) => r.data),
  send: (data) => api.post("/sharing/send", data).then((r) => r.data),
  getReceived: () => api.get("/sharing/received").then((r) => r.data),
  getSent: () => api.get("/sharing/sent").then((r) => r.data),
  importRecipe: (id) => api.post(`/sharing/${id}/import`).then((r) => r.data),
  delete: (id) => api.delete(`/sharing/${id}`),
};
// Add to mealplanApi object - append this line to the existing mealplanApi
// mealplanApi.sendTomorrow = () => api.post("/mealplan/send-tomorrow").then((r) => r.data);
